import { useMemo } from 'react';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { StaffPerformanceOrg } from '@wetags/staff-performance';
import { hasSchemaACL, isWeaveUser } from '@frontend/auth-helpers';
import { useIsCallIntelEligibleAccount } from '@frontend/call-intel-core';
import { useAppScopeStore } from '@frontend/scope';

export const useShowStaffPerformanceNav = () => {
  const [isStaffPerformanceEnabled, isWetagLoading] = StaffPerformanceOrg.useWetag('enable-dashboard');
  const { isCallIntelActive } = useIsCallIntelEligibleAccount();
  const { selectedLocationIds } = useAppScopeStore();

  const hasStaffPerformanceAccess = useMemo(() => {
    return (
      isWeaveUser() ||
      selectedLocationIds.some((id) => hasSchemaACL(id, Permission.STAFF_PERFORMANCE_LEADERBOARD_MANAGE))
    );
  }, [selectedLocationIds]);

  return isCallIntelActive && hasStaffPerformanceAccess && isStaffPerformanceEnabled && !isWetagLoading;
};
